import { FiChevronLeft, FiChevronRight, FiChevronsLeft, FiChevronsRight } from 'react-icons/fi'
import { GrFormNext, GrFormPrevious } from 'react-icons/gr'
import { Link, useLocation } from 'react-router-dom'

export default function Pagination({ pagination }) {
  const location = useLocation()

  const queryParams = new URLSearchParams(location.search)
  queryParams.delete('page')

  if (!pagination) return null
  const hasPrevious = pagination.current_page > 1
  const hasNext = pagination.current_page < pagination.last_page

  return (
    <div
      className="flex items-center gap-2"
      dir="ltr"
    >
      {hasNext ? (
        <Link
          to={hasNext ? `?${queryParams.toString()}&page=${pagination.current_page + 1}` : '#'}
          className={`hover:border-secondary-600 border-muted-300 flex items-center border-2 bg-white p-2 hover:bg-light ${!hasNext ? 'cursor-not-allowed opacity-50' : ''}`}
          aria-disabled={!hasNext}
          disables={hasNext}
        >
          <GrFormPrevious className="h-5 w-5" />
        </Link>
      ) : (
        <div
          className={`hover:border-secondary-600 border-muted-300 flex cursor-not-allowed items-center border-2 bg-white p-2 opacity-50 hover:bg-light`}
          aria-disabled={!hasNext}
          disables={hasNext}
        >
          <GrFormPrevious className="h-5 w-5" />
        </div>
      )}

      {hasPrevious ? (
        <Link
          to={hasPrevious ? `?${queryParams.toString()}&page=${pagination.current_page - 1}` : '#'}
          className={`hover:border-secondary-600 border-muted-300 flex items-center border-2 bg-white p-2 hover:bg-light ${!hasPrevious ? 'cursor-not-allowed opacity-50' : ''}`}
          aria-disabled={!hasPrevious}
        >
          <GrFormNext className="h-5 w-5" />
        </Link>
      ) : (
        <div
          className={`hover:border-secondary-600 border-muted-300 flex cursor-not-allowed items-center border-2 bg-white p-2 opacity-50 hover:bg-light`}
          aria-disabled={!hasPrevious}
        >
          <GrFormNext className="h-5 w-5" />
        </div>
      )}
    </div>
  )
}
